import React from 'react';
import styles from '@dazn/lp-web/src/components/Footer/footer.module.css';
import Trademark from '@dazn/lp-web/src/components/Footer/Trademark';
import {IFooterLinks} from '@dazn/lp-web/src/types/footer.types';
import {useLanguages} from '@dazn/lp-web/src/components/Footer/footer.utils';
import {useFeLabelsState} from '@dazn/lp-web/src/contexts/FeLabelsContext';
import {FOOTER_ID} from '@dazn/lp-web/src/constants/footer.constants';

interface IFooterProps {
    data: IFooterLinks;
    key: number;
    disableAnimation: boolean;
}

const Footer: React.FC<IFooterProps> = ({data}) => {
    const {labels} = useFeLabelsState();
    const {footerLinks} = data;
    const {languages} = useLanguages();

    return (
        <div id={FOOTER_ID} className={styles.footerContainer}>
            <nav>
                <ul className={styles.list}>
                    {languages?.map((footer) => (
                        <li key={`footer-${footer?.value}`}>
                            <a href={footer.href} rel="noreferrer">
                                {labels.get({
                                    stringKey: `signup_language_switcher_${footer.value}_link`
                                })}
                            </a>
                        </li>
                    ))}
                    {footerLinks?.map((footer) => (
                        <li key={`footer-${footer?.value}`}>
                            <a
                                href={footer?.url}
                                onClick={footer.action}
                                rel="noreferrer"
                            >
                                {labels.get({stringKey: footer?.value})}
                            </a>
                        </li>
                    ))}
                    <li>
                        <Trademark />
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Footer;
